import { ref as p, computed as i, onMounted as g, createElementBlock as s, openBlock as a, createElementVNode as r, createBlock as l, createCommentVNode as c, normalizeClass as h, unref as k, createVNode as w, Teleport as x, withKeys as j, withCtx as C } from "vue";
import P from "../image-with-footer/image-with-footer.vue.js";
import S from "../../atoms/image-element/image-element.vue.js";
import $ from "../../atoms/icon/icon.vue.js";
import N from "../../atoms/modal/modal.vue.js";
import { useTracking as B } from "../../composables/useTracking.js";
import { screenProp as L } from "../../utils/utilsScreen.js";
/* empty css                  */
import M from "../../_virtual/_plugin-vue_export-helper.js";
const V = { class: "ds-video-player" }, F = ["aria-label", "data-track-component-name", "data-track-text"], q = { class: "ds-video-player__video-box" }, D = {
  key: 0,
  class: "ds-video-player__video-box__video",
  controls: "",
  "data-j-video-self-hosted": ""
}, I = ["src", "type"], T = ["src", "title"], y = "DsVideoPlayer", E = /* @__PURE__ */ Object.assign({
  name: y
}, {
  __name: "video-player",
  props: {
    ...L,
    /**
     * Thumbnail image source
     * @property {Object} thumbnail.small - { src: String, name: String }
     * @property {Object} thumbnail.medium - { src: String, name: String }
     * @property {Object} thumbnail.large - { src: String, name: String }
     */
    thumbnail: {
      type: Object,
      required: !0
    },
    /**
     * Self-hosted, set to true if the video src value is a file path
     */
    selfHosted: {
      type: Boolean,
      default: !1
    },
    /**
     * Video src
     */
    src: {
      type: String,
      required: !0
    },
    /**
     * Video title
     */
    title: {
      type: String,
      required: !0
    },
    /**
     * Video extension
     */
    extension: {
      type: String,
      default: ""
    },
    /**
     * Aria-label for play button
     */
    ariaLabelPlay: {
      type: String,
      default: "Play"
    },
    /**
     * Aria-label for close modal button
     */
    ariaLabelClose: {
      type: String,
      default: "Close"
    },
    caption: {
      type: String,
      default: ""
    },
    source: {
      type: String,
      default: ""
    },
    isFooterNarrow: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, { trackingDataProvided: f } = B(), o = p(!1), d = p(!1), v = i(() => `${t.ariaLabelPlay} ${t.title}`), n = i(() => t.thumbnail && (t.source || t.caption)), b = i(() => n.value ? { ...t.thumbnail, source: t.source, caption: t.caption } : null), _ = () => {
      o.value = !o.value;
    }, u = () => {
      o.value = !1;
    };
    return g(() => {
      d.value = !0;
    }), (m, H) => (a(), s("div", V, [
      r("div", {
        class: h(["ds-video-player__poster", { "ds-video-player__poster--no-background": n.value }])
      }, [
        n.value ? (a(), l(P, {
          key: 0,
          role: "presentation",
          image: b.value,
          screen: m.screen,
          "is-footer-narrow": e.isFooterNarrow,
          "data-j-thumbnail": ""
        }, null, 8, ["image", "screen", "is-footer-narrow"])) : e.thumbnail ? (a(), l(S, {
          key: 1,
          role: "presentation",
          image: e.thumbnail,
          screen: m.screen,
          "data-j-thumbnail": ""
        }, null, 8, ["image", "screen"])) : c("", !0),
        r("button", {
          class: "ds-video-player__poster__button ds-button-link ds-button-link--primary ds-button-link--black-green",
          type: "button",
          "aria-label": v.value,
          "data-track-component-name": k(f)["component-name"] || y,
          "data-track-text": e.title,
          "data-j-button": "",
          onClick: _
        }, [
          w($, {
            category: "other",
            name: "play-filled"
          })
        ], 8, F)
      ], 2),
      d.value ? (a(), l(x, {
        key: 0,
        defer: "",
        to: "#portal-overlay"
      }, [
        o.value ? (a(), l(N, {
          key: 0,
          "aria-label-close": e.ariaLabelClose,
          "data-j-modal": "",
          onCloseModal: u,
          onKeydown: j(u, ["esc"])
        }, {
          default: C(() => [
            r("div", q, [
              e.selfHosted ? (a(), s("video", D, [
                r("source", {
                  src: e.src,
                  type: `video/${e.extension}`
                }, null, 8, I)
              ])) : (a(), s("iframe", {
                key: 1,
                class: "ds-video-player__video-box__video",
                src: e.src,
                title: e.title,
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowfullscreen: "",
                "data-j-video-embed": ""
              }, null, 8, T))
            ])
          ]),
          _: 1
        }, 8, ["aria-label-close"])) : c("", !0)
      ])) : c("", !0)
    ]));
  }
}), U = /* @__PURE__ */ M(E, [["__scopeId", "data-v-26dfc50f"]]);
export {
  U as default
};
